import { useRef } from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import EmojiButton from '../EmojiButton/EmojiButton';
import { DEFAULT_MESSAGE_MAX_LENGTH } from '../../utils/messageLimits';

export default function MessageField({
  id,
  label = 'Message',
  value,
  onChange,
  rows = 6,
  maxLength = DEFAULT_MESSAGE_MAX_LENGTH,
  placeholder,
  showCounter = true,
  autoFocus = false,
}) {
  const textareaRef = useRef(null);

  return (
    <div className="field">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <label htmlFor={id}>{label}</label>
        <EmojiButton textareaRef={textareaRef} value={value} onInsert={onChange} maxLength={maxLength} />
      </div>
      <InputTextarea
        id={id}
        ref={textareaRef}
        className={showCounter ? 'w-full mb-1' : 'w-full'}
        rows={rows}
        maxLength={maxLength}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoFocus={autoFocus}
      />
      {showCounter && (
        <p className="textMuted mb-3" style={{ textAlign: 'right' }}>
          {value.length} / {maxLength}
        </p>
      )}
    </div>
  );
}
